"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetryButtonWrapper = exports.ErrorMessageWrapper = exports.AnnouncementsListWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const AnnouncementsListWrapper = exports.AnnouncementsListWrapper = _styledComponents.default.div.withConfig({
  displayName: "Liststyle__AnnouncementsListWrapper",
  componentId: "sc-1g883f9-0"
})(["", ";overflow-y:auto;overflow-x:hidden;"], _ref => {
  let {
    maxHeight
  } = _ref;
  return maxHeight && maxHeight > 0 ? "max-height: ".concat(maxHeight, "px") : '';
});
const RetryButtonWrapper = exports.RetryButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "Liststyle__RetryButtonWrapper",
  componentId: "sc-1g883f9-1"
})(["display:flex;margin-top:15px;justify-content:center;"]);
const ErrorMessageWrapper = exports.ErrorMessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Liststyle__ErrorMessageWrapper",
  componentId: "sc-1g883f9-2"
})(["text-align:center;margin:10px 0 20px 0;"]);